<!-- MODAL Cambiar producto-->
<div style="overflow-y: auto;" mdbModal #cambiarProducto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <form autocomplete="off" [formGroup]="formHeader">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">
                        Cambiar producto
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="cambiarProducto.hide()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <h5 class="modal-title w-100 text-left" id="myModalLabel">
                                Producto actual
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col dato">
                            <span class="value value2">
                                {{registro?.nombreProducto}}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <h5 class="modal-title w-100 text-left" id="myModalLabel">
                                Cantidad en quiebre
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col dato">
                            <span class="value value2">
                                {{registro?.cantidad_requerida | numerico}}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <h5 class="modal-title w-100 text-left" id="myModalLabel">
                                Producto nuevo
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col" style="max-width: 150px;">
                            <div class="md-form">
                                <input value="" type="text" id="codProduct" class="form-control" placeholder="000"
                                    required #codProduct formControlName="sku" />
                                <label for="codProduct">Código de producto</label>
                                <div *ngIf="
                                    formHeader.get('sku').invalid &&
                                    (formHeader.get('sku').dirty ||
                                    formHeader.get('sku').touched)
                                ">
                                    <mdb-error *ngIf="formHeader.get('sku').hasError('required')">
                                        Ingrese código de producto
                                    </mdb-error>
                                    <mdb-error *ngIf="formHeader.get('sku').hasError('min')">
                                        Código de producto debe ser mayor a 0 </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex">
                            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                                (click)="openModalSeleccionarProducto()">
                                <mdb-icon fas icon="search"></mdb-icon>
                            </button>
                            <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
                                {{ productoSeleccionado.descripcion}}
                            </h6>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col" style="max-width: 150px;">
                            <div class="md-form">
                                <mdb-select [options]="optionsFormato" [filterEnabled]="true" [highlightFirst]="false"
                                    placeholder="Seleccionar Formato" formControlName="formato"></mdb-select>
                                <label>Formato</label>
                                <div *ngIf="
                                    formHeader.get('formato').invalid &&
                                    (formHeader.get('formato').dirty ||
                                    formHeader.get('formato').touched)
                                  ">
                                    <mdb-error *ngIf="formHeader.get('formato').hasError('required')">Ingrese formato
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                        (click)="cambiarProducto.hide()" mdbWavesEffect>
                        Cerrar
                    </button>
                    <button type="button" class="btn btn-success waves-light" mdbWavesEffect (click)="Cambiar()">
                        Cambiar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
    (onNotFound)="onProductoNoEncontrado()" (onRemoteQuery)="handleRemoteQuery($event)">
</app-modal-seleccionar-producto>